import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { FC } from 'react';

const HomeAnalyticsEmpty: FC = () => (
	<Box
		display="flex"
		flexGrow={1}
		flexDirection="column"
		justifyContent="center"
	>
		<Box
			height={350}
			border={2}
			borderColor="divider"
			borderRadius={1}
			display="flex"
			flexDirection="column"
			justifyContent="center"
			alignItems="center"
			textAlign="center"
			p={3}
			sx={{
				borderStyle: 'dashed'
			}}
		>
			<Typography variant="h6" color="text.disabled">
				{intl.tr('analytics.no.usage.header')}
			</Typography>
		</Box>
	</Box>
);

export default HomeAnalyticsEmpty;
